<section class="container-style">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <small class="text-muted">Copiar desde:</small>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-select [labelText]="'Equipo'" [required]="true" [list]="listMaintenanceRoutines"
        (onChangeSelect)="changeMaintenanceRoutine($event)">
      </app-custom-select>
    </div>
    <div class="col-lg-12 col-md-12 col-12 d-flex justify-content-end mt-3">
      <app-custom-button [title]="'Copiar'" [label]="'Copiar'" [severity]="'primary'" [variant]="undefined"
        (onClick)="copyMaintenanceRoutine()">
      </app-custom-button>
    </div>
  </div>
</section>